import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import * as PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";

import styles from "./LockedItemsModal.module.scss";

const LockedItemsModal = ({ lockedItems = [], handleOk }) => {
  const dispatch = useDispatch();

  if (!lockedItems.length) {
    return null;
  }

  const dispatchHandleOk = () => {
    dispatch(handleOk);
  };

  return (
    <Modal data-testid="locked-items-modal" className="fade-in" show centered>
      <Modal.Header>
        <strong>Cannot Archive — Items Locked</strong>
      </Modal.Header>
      <Modal.Body>
        <p>The following items are currently open by another user:</p>
        <ul className={styles.lockedItemsList}>
          {lockedItems.map((item) => (
            <li
              key={`${item.itemType}-${item.itemName}`}
              className={styles.lockedItem}
            >
              <strong>
                {item.itemName
                  ? `${item.typeLabel} - ${item.itemName}`
                  : item.typeLabel}
              </strong>{" "}
              - is locked by {item.lockedBy}
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-test="okButton"
          variant={NewButtonVariant.l1}
          onClick={dispatchHandleOk}
        >
          Ok
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default LockedItemsModal;

LockedItemsModal.propTypes = {
  lockedItems: PropTypes.arrayOf(
    PropTypes.shape({
      itemType: PropTypes.string,
      itemName: PropTypes.string,
      lockedBy: PropTypes.string,
      typeLabel: PropTypes.string,
    })
  ),
  handleOk: PropTypes.func.isRequired,
};
